module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_7016.d873ea65.png";